import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {Paragraph} from '../Paragraph'
import {InfoBlock} from '../InfoBlock'
import {renderParagraphs} from '../utils';
import {withPrefix} from 'gatsby-link';
import Img from 'gatsby-image';

import './info-section.css'

class InfoSection extends Component {

  render () {
    let img = (this.props.sizes ? <Img sizes={this.props.sizes}></Img> : <div style={{marginTop: -30}}></div>);
    let description = renderParagraphs(this.props.description);

    return (
      <div>
        <Title name = {this.props.title}></Title>
        {img}
        <br></br>
        {description}
      </div>
    );
  }
}


export default {InfoSection}



// WEBPACK FOOTER //
// ./src/components/InfoSection/index.js